import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './lib/auth.jsx'
import Layout from './components/Layout.jsx'
import LoginPage from './pages/LoginPage.jsx'
import DashboardPage from './pages/DashboardPage.jsx'
import ImageTypesPage from './features/image-types/index.jsx'
import ImagesPage from './features/images/index.jsx'
import UsersPage from './features/users/index.jsx'
import HeroPreviewPage from './pages/HeroPreviewPage.jsx'
import LandingPreviewPage from './features/landing/index.jsx'
import KelasPage from './features/kelas/index.jsx'
import { RiLoader4Line } from 'react-icons/ri'

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth()
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <RiLoader4Line className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  if (roles && !user.roles.some((r) => roles.includes(r))) return <Navigate to="/" replace />
  return children
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route
          path="tipe-gambar"
          element={
            <ProtectedRoute roles={['admin', 'super_admin']}>
              <ImageTypesPage />
            </ProtectedRoute>
          }
        />
        <Route path="gambar" element={<ImagesPage />} />
        <Route path="pratinjau-hero" element={<HeroPreviewPage />} />
        <Route path="pratinjau-landing" element={<LandingPreviewPage />} />
        <Route path="kelas" element={<KelasPage />} />
        <Route
          path="pengguna"
          element={
            <ProtectedRoute roles={['super_admin']}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
